const processInclude = require('sfraScripts/util');
$ = require('jquery');

$(document).ready(function() {
	processInclude(require('sfraScripts/productTile'));
	processInclude(require('./components/tab-carousel'));
	processInclude(require('./components/home-responsive-img'));
});
